import React, { useContext } from 'react';
import { GlobalMenu } from '@bingads-webui-react/global-menu';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { withSmartConfig } from './with-smart-config';
import { withSwitchToExpert } from './with-switch-to-expert';
import { withUPConfig } from './with-up-config';

const OriginalGlobalMenuWithSmart = withSwitchToExpert(withSmartConfig(GlobalMenu));
const GlobalMenuWithUP = withUPConfig(GlobalMenu);

export const GlobalMenuWithSmart = (props) => {
  const permissions = useContext(PermissionsContext);
  const isUnifiedSmartMode = !!permissions.IsUnifiedSmartMode;

  return (
    isUnifiedSmartMode
      ? <GlobalMenuWithUP {...props} />
      : <OriginalGlobalMenuWithSmart {...props} />
  );
};
